// errors Copyright 2022 Rebecca L Beaudet
import { SUPPORT_EMAIL } from './constantContent';
const errorMsg = {
    badRobots: `The robots are being uncooperative, Sorry about this inconvenience, it's possible to contact us at ${SUPPORT_EMAIL}`,
    noResponseFromUs: `Sorry we did not get a response from our robot. Please try again later. If this issue persists, please contact ${SUPPORT_EMAIL}`,
    noClientSecretForStripe: `Sorry, there was an error in setting proper payment details. Please contact ${SUPPORT_EMAIL} after trying again.`,
    failedPayment: `Sorry, there was an issue you will need to try again, if your payment fails again please contact us at ${SUPPORT_EMAIL}`,
};
export { errorMsg };
